/** Types */

export const GET_TRANSFERS = "GET_TRANSFERS";
export const GET_TRANSFERS_SUCCESS = "GET_TRANSFERS_SUCCESS";

export const RE_TRANSFER = "RE_TRANSFER";
